/* eslint-disable */
import {
  endOfMonth,
  format as dateFnsFormat,
  startOfMonth,
  Locale,
  FormatOptions,
  subMonths,
} from "date-fns";
import { DateTime as Luxon, DurationLike } from "luxon";

declare global {
  interface Date {
    startOfMonth(): Date;
    endOfMonth(): Date;
    subMonths(amount: number): Date;
    minus(duration: DurationLike): Date;
    format(
      format: string,
      options?: {
        locale?: Locale;
        weekStartsOn?: 0 | 1 | 2 | 3 | 4 | 5 | 6;
        firstWeekContainsDate?: 1 | 2 | 3 | 4 | 5 | 6 | 7;
        useAdditionalWeekYearTokens?: boolean;
        useAdditionalDayOfYearTokens?: boolean;
      },
    ): string;
    setCentralTime(hours: number): Date;
  }
}

Date.prototype.setCentralTime = function (hours: number) {
  const offset = this.getTimezoneOffset() * 60 * 1000;
  const centralOffset = 6 * 60 * 60 * 1000;
  const date = new Date(this.getTime() - offset + centralOffset);
  date.setUTCHours(hours);
  return date;
};

Date.prototype.startOfMonth = function () {
  return startOfMonth(this);
};

Date.prototype.endOfMonth = function () {
  return endOfMonth(this);
};

Date.prototype.subMonths = function (amount: number) {
  return subMonths(this, amount);
};

Date.prototype.minus = function (duration: DurationLike) {
  return Luxon.fromJSDate(this).minus(duration).toJSDate();
};

Date.prototype.format = function (
  format: string,
  options?: {
    locale?: Locale;
    weekStartsOn?: 0 | 1 | 2 | 3 | 4 | 5 | 6;
    firstWeekContainsDate?: 1 | 2 | 3 | 4 | 5 | 6 | 7;
    useAdditionalWeekYearTokens?: boolean;
    useAdditionalDayOfYearTokens?: boolean;
  },
) {
  return dateFnsFormat(this, format, options as FormatOptions);
};
export default {};
